import React from "react";
import { pages } from "@/routes/pageImports";
import SessionExpiredPopup from "@/components/SessionExpiredPopup";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const RoleBasedRedirect = () => {
  const auth = useSelector((state) => state?.auth);
  
  const userRole = auth?.role || '';
  
  const roleRedirects = {
    'STUDENT': '/student/login',
    'PLACEMENT_OFFICER': '/po/login',
    'HUMAN_RESOURCE': '/hr/login'
  };
  
  const redirectPath = roleRedirects[userRole] || '/student/login';
  
  return <Navigate to={redirectPath} replace />;
};


const publicRoutes = [
  { path: '/', element: <RoleBasedRedirect /> },
  { path: "/session", element: <SessionExpiredPopup /> },
  { path: "/:userType/reset", element: <pages.ResetPasswordPage /> },
  { path: "/:userType/reset-otp", element: <pages.CommonOtpPage /> },
  { path: "/:userType/new-password", element: <pages.CreatePassPage /> },
  { path: "/not-authorized", element: <pages.NotAuthorized /> },
  { path: "/page-not-found" , element: <pages.PageNotFound /> },
  { path: "/no-access" , element: <pages.AccessDeniedIndex /> },
  { path: "/profile/*", element: <pages.StudentPortfolioIndex /> },
  { path: "/:userType/:type/havingissue", element: <pages.HavingIssues /> },
  { path: "/:userType/term-and-condition" , element: <pages.TermCondition /> },
  { path: "/:userType/logout" , element: <pages.Logout /> },
  { path: "/po/payment" , element: <pages.PaymentStatusView /> },
  { path: "/:userType/privacy-policy" , element: <pages.PrivacyPolicy /> },

  { path: "/demo" , element: <pages.PersonaldocumentsPage /> },

];

export default publicRoutes;
